import {ISubmissionProps} from '../../resources/submission';

export const getIndicators = (submissions: ISubmissionProps[]) => {
    const values = {
        socialDays: 0,
        socialMeetings: 0,
        culturalSocialInitiatives: 0,
    }

    submissions.forEach(submission => {
        if (['6', '7'].includes(submission.question8?.toString() ?? '')) {
            values.socialDays++;
        } else if (['1', '2', '3', '4', '5'].includes(submission.question8?.toString() ?? '')) {
            values.socialMeetings++;
        }

        if (['1', '2', '3', '4', '5', '6', '7'].includes(submission.question5?.toString() ?? '')) {
            values.culturalSocialInitiatives++;
        }
    })

    return Object.values(values);
}